'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2, _initialiseProps; /**
                                       * 登录组件
                                       */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _zoroCookie = require('@alife/zoro-cookie');

var _zoroCookie2 = _interopRequireDefault(_zoroCookie);

var _dialog = require('@alife/zoro-base/lib/dialog');

var _dialog2 = _interopRequireDefault(_dialog);

var _batman = require('./batman');

var _batman2 = _interopRequireDefault(_batman);

var _util = require('./util');

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BatmanDialog = (_temp2 = _class = function (_React$Component) {
    (0, _inherits3.default)(BatmanDialog, _React$Component);

    function BatmanDialog() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BatmanDialog);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BatmanDialog.__proto__ || Object.getPrototypeOf(BatmanDialog)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    // hack一下当出现购物券时，点击关闭直接刷新页面


    // 弹框关闭后事件


    // 带coupon登录后，关闭弹框，需要刷新页面


    (0, _createClass3.default)(BatmanDialog, [{
        key: 'afterOpen',
        value: function afterOpen() {
            var dialog = document.getElementById('batman-dialog-wrap');
            dialog.parentElement.id = 'batman-dialog-overlay-wrap';
        }
    }, {
        key: 'render',
        value: function render() {
            var classNames = (0, _classnames2.default)('batman-dialog-wrap', this.props.className);
            if (this.props.children) {
                // 如果有子元素，则认为是弹窗模式，点击该元素弹出batman
                return _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.cloneElement(this.props.children, {
                        onClick: this.onClick
                    }),
                    this.state.visible ? _react2.default.createElement(
                        _dialog2.default,
                        {
                            id: 'batman-dialog-wrap',
                            className: classNames,
                            visible: this.state.visible,
                            onClose: this.onClose,
                            footer: false,
                            overlayProps: { afterOpen: this.afterOpen, offset: [0, -50] },
                            shouldUpdatePosition: true
                        },
                        _react2.default.createElement(_batman2.default, (0, _extends3.default)({
                            afterWithCouponJoin: this.afterWithCouponJoin
                        }, this.props, {
                            type: 'dialog',
                            always: this.always
                        }))
                    ) : null
                );
            } else {
                return _react2.default.createElement(_batman2.default, (0, _extends3.default)({ className: this.props.className }, this.props));
            }
        }
    }]);
    return BatmanDialog;
}(_react2.default.Component), _class.propTypes = {
    /**
     * 组件默认展示tab
     */
    tab: _propTypes2.default.oneOf(['join', 'login']),
    /**
     * 是否显示join模块
     */
    hasJoin: _propTypes2.default.bool,
    /**
     * 是否可见
     */
    visible: _propTypes2.default.bool,
    /**
     * 注册包含的参数
     */
    joinParams: _propTypes2.default.shape({
        /**
         * sessionId
         */
        sessionId: _propTypes2.default.string,
        /**
         * couponCode
         */
        couponCode: _propTypes2.default.string,
        /**
         * 后台统计注册来源
         */
        registerFrom: _propTypes2.default.string,
        /**
         * 注册表单提交路径
         */
        registerAction: _propTypes2.default.string,
        /**
         * 是否送优惠劵
         */
        isSendCoupon: _propTypes2.default.bool
    }),
    loginParams: _propTypes2.default.shape({
        /**
        * 后台登录来源
        */
        loginFrom: _propTypes2.default.string
    }),
    /**
     * 关闭弹窗回调
     */
    afterClose: _propTypes2.default.func,
    /**
     * 注册成功回调
     */
    afterJoin: _propTypes2.default.func,
    /**
     * 登录成功回调
     */
    afterLogin: _propTypes2.default.func,
    /**
     * 注册或者登录后的回调
     */
    always: _propTypes2.default.func,
    /**
     * 验证函数，成功再判断是否登录
     */
    validate: _propTypes2.default.func,
    /**
     * 验证失败触发回调
     */
    validateFail: _propTypes2.default.func,
    /**
     * 类名
     */
    className: _propTypes2.default.string,
    /**
     * 子元素
     */
    children: _propTypes2.default.any
}, _class.defaultProps = {
    validate: function validate() {
        return true;
    },
    validateFail: function validateFail() {} }, _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.closeHandle = null;
    this.state = {
        visible: false };

    this.onClose = function () {
        _this2.setState({
            visible: false
        });
        _this2.props.afterClose && _this2.props.afterClose();
        _this2.closeHandle && _this2.closeHandle();
    };

    this.afterWithCouponJoin = function () {
        _this2.closeHandle = function () {
            // TODO
            window.location.reload();
        };
    };

    this.onClick = function () {
        // 先判断用户设置的验证
        if (_this2.props.validate()) {
            // TODO 更好的判断方式
            if (_zoroCookie2.default.isLoggedIn()) {
                _this2.props.always && _this2.props.always({ direct: true });
            } else {
                _this2.setState({
                    visible: true
                });
            }
        } else {
            _this2.props.validateFail();
        }
    };

    this.always = function () {
        var _props;

        _this2.setState({
            visible: false
        });
        (0, _util.trigger)('refreshLogin');
        _this2.props.always && (_props = _this2.props).always.apply(_props, arguments);
    };
}, _temp2);
exports.default = BatmanDialog;